import { getYAxisData, Y_AXIS_MAX_DECIMALS } from '@griply/utils';
import { useMemo } from 'react';
import { MinimalEntry } from 'shared/lib/recharts';
import { formatNumberShort } from 'shared/utils/format-number-short';

export type Options = {
  startValue?: number;
  endValue?: number;
  // caps only the top of the domain; the bottom keeps using endValue
  maxEndValue?: number;
};

export const useYAxisData = (
  data: MinimalEntry[],
  { startValue = 0, endValue, maxEndValue }: Options,
) => {
  const { domain, ticks } = useMemo(
    () => getYAxisData(data, { startValue, endValue, maxEndValue }),
    [data, endValue, maxEndValue, startValue],
  );

  const maxCharacters = useMemo(
    () =>
      ticks.reduce((acc, tick) => {
        const { length } = formatNumberShort(
          tick,
          undefined,
          Y_AXIS_MAX_DECIMALS,
        );
        return acc > length ? acc : length;
      }, 0),
    [ticks],
  );

  return {
    domain,
    ticks,
    maxCharacters,
  };
};
